import gql from 'graphql-tag'
import client from '@stores/apollo'
import { ApolloQueryResult } from 'apollo-client'

interface Payload {
  viewer: {
    company: {
      types: { employeeTitle: string[] }
    }
  }
}

export default function employeeTitles(): Promise<string[]> {
  return client.gql
    .query({ query: employeeTitlesQuery })
    .then((res: ApolloQueryResult<Payload>) => {
      if (res.data) {
        return res.data.viewer.company.types.employeeTitle
      }
      console.error('Employee titles are null', res.errors)
      return []
    })
}

export const employeeTitlesQuery = gql`
  query employeeTitles {
    viewer {
      company {
        types {
          employeeTitle
        }
      }
    }
  }
`
